"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/VEFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_245)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_245`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#FFCE00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 8H30V16H-6V8Z",
					fill: "#203899"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V24H-6V16Z",
					fill: "#D82B2B"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.4081 8.60803L13.6321 9.34403L14.3521 9.56803L13.7281 10L13.7441 10.768L13.1361 10.304L12.4161 10.544L12.6561 9.84003L12.2081 9.23203H12.9601L13.4081 8.60803ZM10.5761 8.60803L11.0081 9.23203H11.7601L11.3121 9.84003L11.5521 10.56L10.8321 10.304L10.2241 10.752L10.2401 10L9.61606 9.55203L10.3361 9.34403L10.5761 8.60803ZM16.0801 9.50403L16.0641 10.272L16.6881 10.704L15.9521 10.928L15.7281 11.648L15.2961 11.04H14.5281L14.9921 10.432L14.7521 9.71203L15.4721 9.96803L16.0801 9.50403ZM7.90406 9.53603L8.54406 9.96803L9.24806 9.68003L9.04006 10.416L9.52006 10.992L8.76806 11.024L8.35206 11.664L8.09606 10.96L7.36006 10.768L7.95206 10.288L7.90406 9.53603ZM18.3841 11.408L18.0641 12.112L18.4641 12.752L17.7121 12.672L17.2161 13.248L17.0561 12.512L16.3681 12.224L17.0241 11.84L17.0721 11.088L17.6321 11.584L18.3841 11.408ZM18.6881 13.2L19.0241 13.888L19.7761 14L19.2321 14.528L19.3601 15.264L18.6881 14.912L18.0161 15.264L18.1441 14.528L17.6001 14L18.3521 13.888L18.6881 13.2ZM5.20006 13.12L5.53606 13.808L6.28806 13.904L5.74406 14.432L5.87206 15.184L5.20006 14.832L4.52806 15.184L4.65606 14.432L4.11206 13.904L4.86406 13.808L5.20006 13.12ZM5.69606 11.28L6.41606 11.504L7.02406 11.04V11.808L7.64806 12.224L6.92806 12.464L6.72006 13.2L6.27206 12.592L5.52006 12.608L5.95206 12L5.69606 11.28Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_245`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as VEFlag };
